import api from '../../services/api';

export interface INotificationWeb {
  tipo: 'web';
  id: number;
  user_id: string;
  content: string;
  created_at: string;
  updated_at: string;
  readed_at: string | null;
  deleted_at: null;
  attachment: string | null;
  response_text: string | null;
  response_attachment: string | null;
}

export interface INotificationRAFAM {
  tipo: 'rafam';
  id: string;
  tipo_imponible: string;
  nro_imponible: string;
  tipo_comprob: string;
  nro_comprob: string;
  created_at: string;
  readed_at: string | null;
  payed: string;
  response_text: string | null;
  response_attachment: string | null;
}

export type INotification = INotificationRAFAM | INotificationWeb

async function getNotifications() {
  const response = await api<INotification[]>('GET', 'notificaciones');
  return response;
}

async function getUnreadNotNumber() {
  const response = await api<number>('GET', 'notificaciones/status');
  return response;
}

async function setReadNotification(id: number | string) {
  const response = await api<INotification>('POST', `notificaciones/${id}/read`);

  return response;
}

export interface ReplyNotificationParams {
  notification: INotification;
  content: string;
  attachment?: File;
}

async function replyNotification(params: ReplyNotificationParams) {
  const { notification, ...data } = params;

  let id = '';
  if (notification.tipo === 'web') {
    id = notification.id.toString();
  } else {
    id = notification.tipo_comprob + '-' + notification.nro_comprob;
  }

  const response = await api<INotification>('POST', `notificaciones/${ id }/reply`, data);

  return response;
}

const notificationsAPI = {
  getNotifications,
  getUnreadNotNumber,
  setReadNotification,
  replyNotification,
};

export default notificationsAPI;
